import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { sortSearchParam } from '@/components/data-table/tableSort';

// Đã chuyển sang mục Lưu trữ; giữ đường cũ để link và dấu trang vẫn mở được.
export const Route = createFileRoute('/_authenticated/settings/archived')({
  validateSearch: z.object({ s: sortSearchParam }),
  beforeLoad: ({ search }) => { throw redirect({ to: '/archive/projects', search: { s: search.s }, replace: true }); },
});
